__turbopack_context__.v({
  "fade-in": "InlineIntro-module-scss-module__5UWEAq__fade-in",
  "root": "InlineIntro-module-scss-module__5UWEAq__root",
});
